import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ShieldCheck } from 'lucide-react';

export default function SafetyPage() {
  return (
    <div className="min-h-screen bg-white pb-24 md:pb-12" data-testid="safety-page">
      <div className="max-w-3xl mx-auto px-4 py-8 md:py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-gray-900 mb-6">
          <ArrowLeft className="w-4 h-4" />वापस जाएं
        </Link>
        <div className="flex items-center gap-3 mb-8">
          <ShieldCheck className="w-8 h-8 text-red-600" />
          <h1 className="font-outfit font-bold text-3xl text-gray-900">Gumsuda Child Safety Standards</h1>
        </div>

        <div className="prose prose-gray max-w-none space-y-6 text-gray-700 leading-relaxed">
          <p className="text-lg">Our app strictly prohibits any form of child sexual abuse material (CSAM) and exploitation.</p>

          <p>We are committed to providing a safe environment for all users. Any content involving minors is carefully reviewed and monitored.</p>

          <section>
            <h2 className="font-outfit font-bold text-xl text-gray-900 mb-3">Safety Measures:</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Users cannot upload inappropriate or illegal content.</li>
              <li>All user submissions are subject to moderation.</li>
              <li>Users can report any harmful or suspicious content.</li>
              <li>Immediate action is taken against violating content.</li>
            </ul>
          </section>

          <p>We cooperate with law enforcement authorities in case of any illegal activity.</p>

          <p className="font-semibold">If you find any content that violates our policies, please contact us immediately.</p>

          <p><strong>Contact:</strong> support@gumsuda.com</p>
        </div>
      </div>
    </div>
  );
}
